import { NavLink, useParams } from "react-router";
import { ProcessPageMainTemplate } from "../../_components/process-page-main-template";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { CustomerName } from "@/services/backend/customers/components/customer-name";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { ProcessNumber } from "@/services/backend/numbers/components/process-number";
import t from "@/lang/lang";
import { CalculationIndexRoute } from "./_components/calculation-index-route";

export function CalculationsRoute() {
  const { processId } = useParams();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  if (!data) return null;

  const breadcrumbs = (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbLink asChild>
            <NavLink
              to={`/customers/${data.customerId}`}
              aria-disabled={!data.customerId}
            >
              <CustomerName customerId={data.customerId} />
            </NavLink>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbLink asChild>
            <NavLink to={`/processes/vbs/${data.id}`}>
              <ProcessNumber processId={data.id} className="font-mono" />
            </NavLink>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage>{t("Kalkulationen")}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <CalculationIndexRoute />
    </ProcessPageMainTemplate>
  );
}
